// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AttachmentKind,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  bugReportId: __t.u64().name("bug_report_id"),
  get kind() {
    return AttachmentKind;
  },
  filename: __t.string(),
  size: __t.u32(),
  uploadedAt: __t.timestamp().name("uploaded_at"),
  blobPath: __t.option(__t.string()).name("blob_path"),
});
